import { combineReducers } from 'redux';
import markets from './marketsReducer';
import slip from './slipReducer';
import app from './appReducer';
import auth from './authReducer';
import liveScore from './liveScoreReducer';
const BYOReducer = combineReducers({
    markets,
    slip,
    app,
    auth,
    liveScore,
});
export default BYOReducer;
